import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { numberWithCommas } from 'site-modules/shared/utils/string';
import { SrpSortBy } from 'site-modules/shared/components/inventory/srp-sort-by/srp-sort-by';
import { SrpSaveSearch } from 'site-modules/shared/components/inventory/srp-save-search/srp-save-search';
import { UsurpSaveSearch } from 'site-modules/shared/components/inventory/usurp-save-search/usurp-save-search';

import './srp-cards-top-panel.scss';

export const SrpCardsTopPanel = memo(
  ({ inventoryCount = null, selectedFacets = {}, onUpdate, withRange = false, isMobile = false }) => {
    if (!inventoryCount) return null;

    return (
      <div className="srp-cards-top-panel d-flex">
        <span className="size-14 text-cool-gray-40" aria-live="polite" role="status" aria-atomic>
          {numberWithCommas(inventoryCount)} listings
        </span>
        <div className="search-separate mx-0_5 mx-md-1" />
        <SrpSortBy onUpdate={onUpdate} selectedFacets={selectedFacets} withRange={withRange} />
        {!isMobile && (
          <>
            <div className="search-separate mx-0_5 mx-md-1" />
            <SrpSaveSearch CustomView={UsurpSaveSearch} showModal />
          </>
        )}
      </div>
    );
  }
);

SrpCardsTopPanel.displayName = 'SrpCardsTopPanel';

SrpCardsTopPanel.propTypes = {
  onUpdate: PropTypes.func.isRequired,
  selectedFacets: PropTypes.shape({}),
  inventoryCount: PropTypes.number,
  withRange: PropTypes.bool,
  isMobile: PropTypes.bool,
};
